import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import banner from "../../images/permeablePavers/permeable-blog-banner.jpg";
import img001 from "../../images/permeablePavers/permeable-blog-1.jpg";
import img002 from "../../images/permeablePavers/permeable-blog-2.jpg";
import img003 from "../../images/permeablePavers/permeable-blog-3.jpg";
import img004 from "../../images/permeablePavers/permeable-blog-4.jpg";
import img005 from "../../images/permeablePavers/permeable-blog-5.jpg";
import img006 from "../../images/permeablePavers/permeable-blog-6.jpg";
import img007 from "../../images/permeablePavers/permeable-blog-7.jpg";
import img008 from "../../images/permeablePavers/permeable-blog-8.jpg";
import img009 from "../../images/permeablePavers/permeable-blog-9.jpg";
import img010 from "../../images/permeablePavers/permeable-blog-10.jpg";
import img011 from "../../images/permeablePavers/permeable-blog-11.jpg";
import img012 from "../../images/permeablePavers/permeable-blog-12.jpg";
import img013 from "../../images/permeablePavers/permeable-blog-13.jpg";
import img014 from "../../images/permeablePavers/permeable-blog-14.jpg";
import img015 from "../../images/permeablePavers/permeable-blog-15.jpg";
import img016 from "../../images/permeablePavers/permeable-blog-16.jpg";
import img017 from "../../images/permeablePavers/permeable-blog-17.jpg";

// SEO
import SEO from "../../../../SEO/index.js";
import StructuredData from "../../../../SEO/structuredData";
import { ViewPavers } from "../../../../CTA/CTA";

export const PermeablePaversData = {
  title: "Designing a Permeable Paver Surface",
  image: banner,
  destination: "/blog/designing-a-permeable-paver-surface",
  date: "August 19, 2015",
  author: "Roy Kimchi",
  categories: ["blog", "permeable-pavers"],
};

const PermeablePavers = () => {
  const blog = [PermeablePaversData];

  return (
    <>
      <SEO
        title="Designing a Permeable Paver Surface & How to Lay "
        description="There are several misconceptions in regards to permeable pavers and the difference between regular pavers. Learn more from our experts today!"
        profileURL={
          "https://www.pacificpavingstone.com/blog/designing-a-permeable-paver-surface"
        }
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "BlogPosting",
          author: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
          URL: "https://www.pacificpavingstone.com/blog/designing-a-permeable-paver-surface",
          headline: "Designing a Permeable Paver Surface & How to Lay",
          description:
            "There are several misconceptions in regards to permeable pavers and the difference between regular pavers. Learn more from our experts today!",
          image: {
            "@type": "ImageObject",
            url: "https://www.pacificpavingstone.com/static/media/permeable-blog-banner.798d537f.jpg",
          },
          datePublished: "2015-08-19",
          publisher: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
        }}
      />
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <p>
              There are several misconceptions in regards to permeable pavers
              and the difference between regular pavers.
            </p>

            <p>
              The standard interlocking paving stone is not permeable and does
              not drain water. Pavers are designed to be flexible but not
              permeable.
            </p>

            <p>
              The base under pavers consists of large gravel, medium sized
              gravel, small gravel and what are called fines (very small
              particles). Since the base is composed of several sizes, they
              compact well and the fines fill the voids making a very tight or
              compact layer.
            </p>

            <p>
              This base material is not meant to drain water but to prevent
              water from draining through it. See the figure below.
            </p>

            <img src={img001} alt="Figure 1" />
            <h4 className="text-center">FIGURE #1</h4>
            <p className="text-blue">
              On the other hand, the base materials for permeable pavers are
              referred to as open graded as they are made up of larger pieces of
              gravel that leave voids where water can easily pass through. See
              figure below:
            </p>

            <img src={img002} alt="Figure 2" />
            <h4 className="text-center">FIGURE #2</h4>
            <p className="text-blue">
              THE PURPOSE OF PERMEABLE PAVERS IS TO ALLOW THE WATER TO DRAIN
              THROUGH TO THE AQUIFER.
            </p>
            <p>
              In order to do that, the water must pass through the pavers, the
              open graded base and then the subgrade or subsoil, until it
              arrives at an aquifer or ground water.
            </p>
            <p className="text-blue">
              The other difference is the joint size; a permeable paver has a
              much wider joint than a standard paver.
            </p>

            <div className="row justify-content-center">
              <div className="col-md-6 text-center">
                <img src={img003} alt="Feature" />
                <p>Permeable Paver</p>
              </div>
              <div className="col-md-6 text-center">
                <img src={img004} alt="Feature" />
                <p>Standard Paver</p>
              </div>
            </div>

            <p>
              Regular pavers should be treated just like any solid surface such
              as concrete. The surface should slope away from the house and
              surface drains should be installed as needed to handle the water.
            </p>

            <p>
              Permeable pavers are designed to allow the water to drain through
              them and into the open graded base and then into the soil, called
              the sub soil. The opened graded base may consist of several
              different sizes of rock but we will refer to it as open graded
              base which acts as a holding tank for the water until it can seep
              into the soil below it called subgrade or subsoil.{" "}
            </p>

            <p>
              The design and the depth of this holding tank depends are several
              factors: the subgrade, the area runoff, the amount of rainfall for
              your region, the slope of the pavers and extreme slopes.
            </p>

            <h4 className="text-center">THE SUBGRADE</h4>
            <p>
              When designing a permeable paver installations consider the
              function and purpose of three layers;
            </p>
            <ol>
              <li>The pavers – joints wide enough to allow water to pass.</li>
              <li>
                The open graded base – a holding tank to give time for the water
                to seep into the subgrade.
              </li>
              <li>
                The subgrade – to filter the water as it seeps into the aquifer.
              </li>
            </ol>

            <p>
              Since the purpose is to return the water to the aquifer and the
              rainwater needs to pass through the subgrade it will need enough
              time to do so. If the subgrade is sandy gravel it will pass
              through very rapidly, if it has a high clay content it will an
              extreme amount of time.
            </p>

            <p>
              So the first and most important thing to consider is the subgrade.
              If the natural subgrade is composed of sand and gravel you would
              not need to be very deep because the water will drain rapidly. If
              the soil has high clay content which naturally holds water and
              does not allow it to drain the holding tank will need to be much
              deeper in order the give time for the water to seep into the
              subgrade. It
            </p>

            <p>
              The soil below the surface then becomes the most important part of
              the calculation and the one most often ignored! Soils are
              classified according to particle size. The larger the size such as
              sand or gravel the better they drain. The smallest size of
              particles are classified as clay and do not drain well.
            </p>

            <p>
              As far as time goes sandy-gravel soil will drain in the manner of
              minutes. Soil with a high clay content in the manner of hours, in
              some cases up to 100 times faster. It would follow that the
              holding tank in this extreme would need to be 100 times larger.
              Doing all the other calculations and ignoring the permeability of
              the soil itself does not make sense.
            </p>

            <p>
              Before spending tens of thousands of dollars on a permeable
              surface it is well worth it to spend a few hundred dollars to test
              the soil and do the needed calculations so you have the most
              effective system.
            </p>

            <p>
              There is a field test that can be done to get a good idea of the
              type of soil you are dealing with that is discussed in an Article
              called “How to test soil for Permeability.” There is enough
              information in that subject that warrants its own discussion. For
              this article we have considered the soil will drain so let’s look
              at the other factors involved.
            </p>

            <h4 className="text-center">THE AREA OF RUNOFF</h4>

            <p>
              The runoff could be coming from other areas on the property and
              other structures. Or in other words the surface area that the
              rainwater will fall on and then be directed to run over the
              permeable surface. This could be the permeable surface itself or
              it could be from the house, garage and other concrete areas as
              shown in
            </p>

            <p>
              In FIGURE #3 below the permeable pavers are only designed to
              handle only the water that falls on the permeable surface. The
              total area of this surface is 100 square feet.
            </p>

            <img src={img005} alt="Figure 3" />
            <h4 className="text-center">FIGURE #3</h4>
            <p className="text-blue">
              In FIGURE #4 the rainfall that is being directed to the permeable
              pit includes the permeable surface, the house, the garage and the
              patio. The total area of this surface is 4000 square feet.
            </p>

            <img src={img006} alt="Figure 4" />
            <h4 className="text-center">FIGURE #4</h4>
            <p>
              Let’s look at the different types of material that can be placed
              in our open graded pit or the holding tank.
            </p>

            <div className="row justify-content-center">
              <div className="col-md-4 text-center">
                <img src={img007} alt="Feature" />
                <p className="text-blue">#2 Rock</p>
              </div>
              <div className="col-md-4 text-center">
                <img src={img008} alt="Feature" />
                <p className="text-blue">3/4-inch Gravel</p>
              </div>
              <div className="col-md-4 text-center">
                <img src={img009} alt="Feature" />
                <p className="text-blue">Course Sand</p>
              </div>
            </div>

            <p>
              Surprisingly ¾ inch gravel holds 48% of its volume or in this case
              480 gallons.
            </p>

            <p>
              Pea gravel that 3/8 inch holds 47% of its volume or 470 gallons.
            </p>

            <p>Course sand holds about 35% of its volume or 350 gallons.</p>

            <img src={img010} alt="Feature" />

            <p>
              The three different sizes of rock are used to create stability.
              After placing each layer a vibrating compactor is used to settle
              the rock. The ¾ inch gravel fills some of the voids in the 1 ½
              inch and bigger stone and the ¼ inch to 3/8 inch fills some of the
              voids in the ¾ inch. The resulting area of the holding tank will
              be able to hold between 47% to 50% of the rain water that is being
              directed to the surface. For this tutorial we will use 50% to make
              the calculations easier.
            </p>

            <h4 className="text-center">HOW DEEP IS THE HOLDING TANK?</h4>

            <p>
              The amount of rainfall varies widely depending on the geographical
              area. In our example we will use 1 inch of rainfall in one hour.{" "}
            </p>

            <p>
              If the surface area is 1000 square feet as in FIGURE #4 and the
              rain falls directly on the surface and then is stored in the open
              graded rock or gravel until the water can seep into the soil
              below. To hold this amount of water the open graded base only
              needs to be 2 inches in depth because it will hold half the
              rainfall per inch.{" "}
            </p>

            <p>
              The holding tank is full and subgrade will need to drain the water
              before the next 1 inch of water will fall so that it will have a
              place to go. If it will take 48 hours for the water to drain then
              one would have to look at the rainfall table for their area and
              design the tank to hold that maximum amount of rainfall over a 48
              hour period. If that happens to be 4 inches then the holding tank
              needs to be 8 inches in depth.
            </p>

            <p>
              If the water from FIGURE #4 above was all directed to the
              permeable surface the runoff area is now the SF of the house + the
              garage + the concrete patio + the permeable surface itself or 4000
              SF. This has increased the volume of the holding tank by four
              times. The depth of the base then will need to be 32 inches to
              hold the water to give it time to seep into the soil below.
            </p>

            <p>
              This is why it is vital to know how long it will take the subsoil
              to drain the water before one can correctly design a permeable
              system.
            </p>

            <h4 className="text-center">AMOUNT OF RAINFALL IN YOUR REGION</h4>
            <p>
              There is a U.S, climate data table that is retrievable from the
              internet for each region in the U.S. The one below is for Los
              Angeles.
            </p>

            <img src={img011} alt="Feature" />
            <p>
              Some judgement needs to be used in designing a system. Looking
              over the tables one can see that in March the average rainfall is
              5.08 inches over 31 days designing a system around 3 inches in a
              48 hour period would result in capturing over 90% of the rainfall.
            </p>

            <p>
              Remember we are using a 48 hour period as an example of the time
              it would take the average soil in the LA basin to handle 3 inches
              of rainfall. But before designing the system be sure to read the
              article on “How to Test for Permeability” and use the drainage
              rates of the subgrade where the permeable pavers will be
              installed.
            </p>

            <p>
              For the other 10% it is wise to install an overflow drain in your
              system so handle the water when it exceeded that amount.
            </p>

            <img src={img012} alt="Feature" />
            <p>
              This drawing shows a perforated pipe installed at the bottom of
              the holding tank. It could easily to plumbed so that the water
              would not exit until the holding tank filled up.
            </p>

            <h4 className="text-center">THE SLOPE OF THE SURFACE</h4>
            <p>
              The effective area of the holding tank is decreases on sloping
              surfaces. The water will follow a level line as can be seen in the
              diagram below and as the surface gets steeper the effective area
              decreases.{" "}
            </p>
            <img src={img013} alt="Feature" />

            <p>
              The blue area represents the water being stored and as you will
              notice it is just over half of the holding tank.
            </p>

            <p>
              Once the surface is over a 12% slope permeable pavers are no
              longer effective as too much to the water will run down the grade
              and not through the opening in the pavers. In this case it is best
              to design the holding tank at the bottom end of the slope as shown
              in figure 6.
            </p>
            <img src={img014} alt="Feature" />

            <p>
              In the above diagram the holding tank has been increased on the
              downhill side of the slope to increase the holding area lost by
              the uphill portion that will not hold water.
            </p>

            <img src={img015} alt="Feature" />
            <p className="text-blue">
              The above diagram shows how most of the water on an 8% will go
              into the holding tank but some will runoff the surface entirely.
            </p>

            <h4 className="text-center">STEEP SLOPES</h4>
            <p>
              If a slope is at 15% most of the water will run off the surface
              and not into the holding tank.
            </p>

            <img src={img016} alt="Feature" />
            <img src={img017} alt="Feature" />
            <p>
              A channel drain place at the end of a sloping driveway and far
              enough away from the garage floor to catch the water coming down
              the slope. The holding tank can be increased and the water from
              the channel drain can be directed into the tank.
            </p>

            <h4 className="text-center">REVIEW</h4>
            <p>
              As a review these are the factors that must be considered in order
              to correctly design a permeable paving stone surface.
            </p>
            <ol>
              <li>The type so subsoil and its permeability</li>
              <li>How much rainfall for the geographical area</li>
              <li>
                The total square footage of surface area that will be directed
                to the permeable pavers.
              </li>
              <li>The slope of the permeable pavers.</li>
            </ol>

            <p>
              It turns out that a permeable paver surface is not feasible for
              certain location. In this case the water can still be trapped and
              storage and used for landscape irrigation. Look for an Article on{" "}
              <i>“Rainwater Harvesting Systems.”</i>
            </p>
            <ViewPavers/>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(PermeablePavers);
